import DocumentoFirmatoNonValidoView from "./DocumentoFirmatoNonValidoView";

export default function DocumentoFirmatoNonValidoController() {

    return (
        <DocumentoFirmatoNonValidoView/>
    );

}